// extracted by mini-css-extract-plugin
export default {"OTPContainer":"OTP_OTPContainer__Z9A01","OTPInput":"OTP_OTPInput__8wWIY","HasData":"OTP_HasData__XB0ur"};